module.exports = __webpack_public_path__ + "img/sticky-note-to-ship-code.4f2ec3a9.jpg";